import { LanguagePicker } from 'views/pickers';
import React from 'react';
import { accountActions } from 'core/Account';
import { config } from 'config';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Container,
    ExpandButton,
    FormGroup,
    Input,
    LinkLabel
} from 'mol-ui';
import {
    ErrorMessage,
    LoginLayout
} from 'views/components';
import {
    Subtitle,
    Version
} from './styled';
import {
    useDispatch,
    useObjectState,
    useQuery,
    useSelector
} from 'hooks';
const {
    apiUrl,
    availableLanguages,
    defaultLanguage,
    redirectAfterLogin,
    ssoLogin,
    version
} = config;

const Login = () => {

    const dispatch = useDispatch();
    const { error } = useSelector('account');
    const { configurations } = useSelector('config');
    const { t } = useTranslation();
    const { redirect } = useQuery();
    const { push } = useHistory();

    const [values, , setValue] = useObjectState({
        email: '',
        language: defaultLanguage,
        password: ''
    });
    const { email, password } = values;

    const handleChangeInput = id => value => {
        setValue(id, value);
        if (error) {
            dispatch(accountActions.setAccountError(''));
        }
    };

    const handleSubmit = () => {
        if (ssoLogin) {
            window.location.href = `${ apiUrl }${ configurations?.sso_login }`;
        }
        if (!!email && !!password) {
            const data = {
                ...values,
                redirect: redirect ? decodeURI(redirect) : redirectAfterLogin
            };
            dispatch(accountActions.loginAccount(data));
        }
    };

    const showLanguagePicker = availableLanguages.length > 1;

    return (
        <LoginLayout title={ t('Bienvenido') }>
            {
                !ssoLogin &&
                <>
                    <Subtitle>{ t('Ingrese sus datos') }</Subtitle>
                    <FormGroup label={ t('Usuario') } marginBottom="10px" >
                        <Input
                            error={ !!error }
                            height="50px"
                            placeholder={ ssoLogin ? '' : t('Ingrese su correo') }
                            type="email"
                            value={ email }
                            onChange={ handleChangeInput('email') }
                            onEnterPress={ handleSubmit }
                        />
                    </FormGroup>
                    <FormGroup label={ t('Contraseña') } marginBottom="5px" >
                        <Input
                            error={ !!error }
                            height="50px"
                            placeholder={ t('Ingrese su contraseña') }
                            type="password"
                            value={ password }
                            onChange={ handleChangeInput('password') }
                            onEnterPress={ handleSubmit }
                        />
                    </FormGroup>
                    <ErrorMessage relative error={ error ?? '' } marginLeft={ 0 } />
                </>
            }
            {
                showLanguagePicker &&
                <FormGroup label={ t('Idioma') } marginBottom="10px">
                    <LanguagePicker
                        onChange={ handleChangeInput('language') }
                    />
                </FormGroup>
            }
            <Container alignItems="center" margin="20px 0px 0px 0px">
                <ExpandButton
                    caption={ t('Ingresar') }
                    disabled={ (email === '' || password === '') && !ssoLogin }
                    size={ 100 }
                    onClick={ handleSubmit }
                    onEnterPress={ handleSubmit }
                />
                {
                    !ssoLogin &&
                    <LinkLabel margin="20px 0px 0px 0px" onClick={ () => push(t('/restablecer')) }>
                        { t('¿Olvidó su contraseña? / Usuario bloqueado') }
                    </LinkLabel>
                }
                <Version>
                    v{ version }
                </Version>
            </Container>
        </LoginLayout>
    );
};

Login.propTypes = {

};

export default Login;
